import ServiceQboAutocomplete from "../../../integrations/QBO/ServiceQboAutocomplete/ServiceQboAutocomplete";
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
const ServiceQboField = _ref => {
  let {
    testid,
    qboItems,
    isDisabled
  } = _ref;
  const {
    control
  } = useFormContext();
  return /*#__PURE__*/React.createElement(Controller, {
    name: "serviceMapping",
    control: control,
    render: _ref2 => {
      let {
        field: {
          value: serviceMapping,
          onChange
        }
      } = _ref2;
      return /*#__PURE__*/React.createElement(ServiceQboAutocomplete, {
        testid: testid,
        isDisabled: isDisabled,
        qboItems: qboItems,
        selectedOption: serviceMapping.type === 'mapped' ? serviceMapping.mappedItem : null,
        showQboMapPlaceHolder: true,
        onQboItemChange: qboItem => onChange(qboItem ? {
          type: 'mapped',
          mappedItem: qboItem
        } : {
          type: 'unmapped'
        })
      });
    }
  });
};
export default ServiceQboField;